export function getRecordMarkerStatus(object) {
  if (!object) {
    return "";
  } else if (object.status == 1 && object.requires_reason == 1) {
    return "tag--danger";
  } else if (
    (object.status == 0 && object.requires_reason != 0) ||
      (object.status == 1 && object.requires_reason != 1)
  ) {
    return "tag--warning";
  } else if (object.status == 0) {
    return "tag--success";
  } else {
    return "";
  }
};
